// src/config/apiConfig.js
const BASE_URL = 'https://farmology.ai';
const FRONTEND_BASE_URL = 'https://farmology.ai';
export default BASE_URL;
export { FRONTEND_BASE_URL };
